module.exports = __webpack_public_path__ + "static/media/appstorebutton.decfb2f0.png";